import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MarketingLayout } from '@/components/layout/MarketingLayout';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { cognitoForgotPassword, mapCognitoErrorMessage } from '@/lib/cognito';
import { useToast } from '@/components/ui/use-toast';

export function EsqueciSenha() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await cognitoForgotPassword(email);
      toast({ variant: 'success', title: 'Código enviado', description: `Verifique seu email: ${email}` });
      navigate(`/resetar-senha?email=${encodeURIComponent(email)}`);
    } catch (err) {
      toast({ variant: 'danger', title: 'Falha', description: mapCognitoErrorMessage(err) });
    } finally {
      setLoading(false);
    }
  }

  return (
    <MarketingLayout>
      <div className="container-px mx-auto max-w-md py-16">
        <Card>
          <CardHeader>
            <CardTitle>Recuperar senha</CardTitle>
            <CardDescription>Enviaremos um código pro seu email.</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-1.5"
                />
              </div>
              <Button type="submit" variant="accent" className="w-full" loading={loading}>
                Enviar código
              </Button>
            </form>
            <p className="mt-6 text-sm text-center">
              <Link to="/login" className="text-muted-foreground hover:text-foreground">
                Voltar ao login
              </Link>
            </p>
          </CardContent>
        </Card>
      </div>
    </MarketingLayout>
  );
}
